// packages/data/src/plugins/index.js
import { default as default2 } from "./persistence";
export {
  default2 as persistence
};
//# sourceMappingURL=index.js.map
